import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LowerCasePipe } from '@angular/common';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css']
})
export class RegistrationComponent implements OnInit {

  constructor(private router: Router) { }
  username;
  password;
send(){
  if(this.username == "marco" && LowerCasePipe){
    if(this.password == "henke" && LowerCasePipe){
      alert("Sie werden weitergeleitet");
      this.myFunction();


      // this.router.navigateByUrl("/workinghours");

    }
    else{
      this.username="";
      this.password ="";
      alert("Überprüfen Sie bitte Ihre eingaben.");

    }
  }
  else{
    this.username="";
    this.password ="";
    alert("Überprüfen Sie bitte Ihre eingaben.");
  }
}
  ngOnInit() {
    document.getElementById("body1").style.backgroundColor ="white";

  }
  myFunction() {

    var x = document.getElementById("myDIV");
    if (x.style.display === "none") {
      x.style.display = "block";
      document.getElementById("myDiv2").style.display = "none";

    } else {
      x.style.display = "none";
      document.getElementById("myDiv2").style.display = "block";

    }
  }


}
